import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import CountriesList from "./countriesList";
import { fetchCountriesList } from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";

const Countries = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [countries, setCountries] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Countries");
    if (perms) {
      setGranted(perms);
    }
  };

  const getCountries = async () => {
    const res = await fetchCountriesList();
    if (res?.data?.success && res?.data?.data) {
      setCountries(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate, "Countries list:");
    }
  };
  useEffect(() => {
    extractPermissions();
    getCountries();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>System Settings</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Countries
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row g-3 mb-3">
            <CountriesList
              countries={countries}
              setCountries={setCountries}
              pagination={pagination}
              setPagination={setPagination}
              granted={granted}
            />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Countries;
